/* ModeSelector — segmented control para alternar entre
 * Formulário Completo e Cadastro Assistido.
 */
import { LayoutList, Wand2, BookMarked } from "lucide-react";

export default function ModeSelector({ value, onChange }) {
  return (
    <div
      className="inline-flex rounded-lg border border-[var(--border)] bg-[var(--surface-2)] p-1 shadow-sm flex-wrap gap-y-1"
      role="tablist"
      aria-label="Modo de cadastro"
      data-testid="cadastro-mode-selector"
    >
      <ModeButton
        active={value === "complete"}
        onClick={() => onChange("complete")}
        icon={<LayoutList size={14} />}
        label="Formulário Completo"
        hint="Indicado para usuários experientes"
        testid="mode-complete"
      />
      <ModeButton
        active={value === "wizard"}
        onClick={() => onChange("wizard")}
        icon={<Wand2 size={14} />}
        label="Cadastro Assistido"
        hint="Passo a passo guiado"
        testid="mode-wizard"
      />
      <ModeButton
        active={value === "sfd"}
        onClick={() => onChange("sfd")}
        icon={<BookMarked size={14} />}
        label="Manual SFD 2026"
        hint="Fluxo aderente ao Manual Sementes de Futuro em Defesa 2026"
        testid="mode-sfd"
      />
    </div>
  );
}

function ModeButton({ active, onClick, icon, label, hint, testid }) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      onClick={onClick}
      title={hint}
      data-testid={testid}
      className={`flex items-center gap-2 px-3.5 py-1.5 text-sm font-medium rounded-md transition ${
        active
          ? "bg-[var(--gold)] text-black shadow"
          : "text-[var(--text-muted)] hover:text-[var(--text)]"
      }`}
    >
      {icon}
      <span>{label}</span>
    </button>
  );
}
